export const BtnStyle = Object.freeze({
	Default: 'default',
	Primary: 'primary',
	Success: 'success',
	Info: 'info',
	Warning: 'warning',
	Danger: 'danger',
});

export const OperatorType = Object.freeze({
	None: 'none',
	Detail: 'detail', //查看详情
	New: 'new', //新增
	Edit: 'edit', //编辑
	Delete: 'delete', //删除
	Refresh: 'refresh', //刷新
	Import: 'import', //导入
	ImportLog: 'importLog', //导入日志
	Export: 'export', //导出
	Apply: 'apply', //申请
	Download: 'download', //下载
	Audit: 'audit', //审批
	ReAudit: 'reAudit', //复核
	Print: 'print', //打印
	Push: 'push', //交付
	Reverse: 'reverse', //冲红
	Copy: 'copy', //复制
	Rebilling: 'rebilling', //重开发票
	Revoke: 'revoke', //撤销
	Deal: 'deal', //处理
	Preview: 'preview', //预览
	Authorization: 'authorization', //授权reset
	ManualAuth: 'manualAuth', //手动授权
	BatchAuth: 'batchAuth', //批量授权
	Cancel: 'cancel', //取消
	Reset: 'reset', //重置
	Query: 'query', // 查询
	Follow: 'follow', // 添加关注
	Unfollow: 'unfollow', // 取消关注
	Assign: 'assign', // 指派
	Enable: 'enable', //  启用
	Disable: 'disable', // 禁用
	Stop: 'stop', // 停用
	PresetRole: 'presetRole', //预置角色
	Check: 'check', //检查
	Associate: 'associate', //关联
	Upload: 'upload', //上传
	Invoicing: 'invoicing', //去开票
	LoginTax: 'loginTax', //登录税务局
	Bjdp: 'bjdp', //标记到票
	Bjrz: 'bjrz', //标记入账
	Hqbs: 'hqbs', //获取版式
	Gxrzzt: 'gxrzzt', //更新认证状态
	UpdateUser: 'updateUser', //修改用户
	UpdatePassWord: 'updatePassWord', //修改密码
	Paste: 'paste', //粘贴
	AddRefinedOil: 'addRefinedOil', //添加成品油
	Setting: 'setting', //设置
	Empower: 'empower	', //赋能
	Default: 'default', //默认
	Ues: 'ues', //使用
	NoUse: 'noUse', //不使用
	Up: 'up', //上移
	Down: 'down', //下移
	OpenService: 'openService', //服务开通
	LoginConfig: 'loginConfig', //登录配置
	TagManage: 'tagManage', //标签管理
	DataRevise: 'dataRevise', //数据调整
	DownloadSetting: 'downloadSetting', //下载设置
	PrintSetting: 'printSetting', //打印设置
	openFile: 'openFile', //打开文件
	ReDownload: 'reDownload', //重新下载
	CustomRefresh: 'customRefresh', //自定义刷新
	AuthAccount: 'authAccount', //授权账号
	CreateAccount: 'createAccount', //创建账号
	UserAuth: 'userAuth', //用户授权
	GetPlate: 'getPlate', //获取版式
	AuthSync: 'authSync', //授权同步
	Retry: 'retry', //重试
	QrCode: 'qrCode', //二维码
	Delay: 'delay', //延期
	Template: 'template', //模板
	AITemplate: 'aiTemplate', //AI模板
	ExceptionHandle: 'exceptionHandle', //异常处理,
    RedRushExceptionHandle: 'redRushExceptionHandle', //红字确认单异常处理,
	Read: 'read', //查看
	FinanceRole: 'financeRole', // 财务角色
	ReApply: 'reApply', // 重新申请
	InfoCollection: 'infoCollection', // 信息采集
	Collect: 'collect', // 采集
	Record: 'record', // 记录
	Resend: 'resend', // 重新发送
	Invitate: 'invitate', // 邀请
	BatchClaim: 'batchClaim', // 批量认领
	Claim: 'claim', // 认领
	Refund: 'refund', // 退款
	Deliver: 'deliver', //  交付
	KpAudit: 'kpAudit', // 开票审核
	KpReAudit: 'kpReAudit', // 开票复核
	RepairLog: 'repairLog', // 修复历史
	MarkRefund: 'markRefund', // 标记退款
});

/**
 * API接口前缀(服务端网关路由+接口地址)
 */
export const ApiPrefix = Object.freeze({
	SysDefault: '/sys/api/v1',
	AuthDefault: '/auth/api/v1',
	LogDefault: '/log/api/v1',
	OpenApiDefault: '/openapi/api/v1',
	DpApiDefault: '/dp/api/v1',
	// 企业相关API
	QyApiDefault: 'qiye/api/v1',
	// 集团版相关API
	GroupDefault: '/group/api/v1',

	// 渠道商
	ChannelDefault: '/channl/api/v1',

	// 云票相关API
	YkpApiDefault: '/ykp',

	//用票相关API
	YpApiDefault: '/jxgl',

	// 手机端
	MobileApiDefault: '/mobileservice',
	// 风险检查
	RiskReport: '/riskReport',

	//税务服务
	TaxApiDefault: '/tax/api/v1',
});

export const TableColWidth = Object.freeze({
	QymcWidth: 271,
	djkz2: 271,
	QyshWidth: 178,
	QybqWidth: 224,
	SwsxWidth: 200,
	BsqyWidth: 96,
	KtfwWidth: 106,
	FzrWidth: 108,
	QyztWidth: 106,

	DateWidth: 121,
	DateTimeWidth: 150,
	PhoneWidth: 128,
	SfzhWidth: 178,

	SdfphmWidth: 192,
	FphmWidth: 106,
	FpdmWidth: 135,

	LargeNumberWidth: 137,
	NormalNumberWidth: 108,
	SmallNumberWidth: 84,

	RemarkWidth: 288,
	NameWidth: 108,
	XhWidth: 80,

	Text2Width: 48,
	Text3Width: 72,
	Text4Width: 96,
	Text5Width: 108,
	Text6Width: 120,
	Text7Width: 132,
	Text8Width: 144,
	Text9Width: 156,
	Text10Width: 168,

	minWidth: 60,
	smallWidth: 80,
	normalWidth: 100,
	largeWidth: 120,
	XLargeWidth: 140,
	XXLargeWidth: 160,
	XXXLargeWidth: 180,
	XXXXLargeWidth: 200,
	XXXXXLargeWidth: 220,
	XXXXXXLargeWidth: 240,

	Index: 50,
	Fplx: 80,
	Qymc: 180,
	Qysh: 160,
	Fpzw: 90,
	Sdphm: 160,
	Fpdm: 105,
	Fphm1: 90,
	Fphm2: 110,
	Date: 90,
	Tdyw: 100,
	Fpbz: 180,
	Hjje: 100,
	Hjse: 100,
	Jshj: 100,
	Fpzt: 90,
	Fpfxdj: 100,
	Time: 135,
	Zzsytbq: 110,
	Zzsgxsq: 110,
	Fprzzt: 110,
	Normal: 100,
});

export const NsrType = Object.freeze({
	Small: '01', //小规模纳税人
	Normal: '02', //一般纳税人
});

export const Fpcxlx = Object.freeze({
	Xxfp: '0', // 销项发票
	Jxfp: '1', // 进项发票
	Jxygx: '2', // 进项已勾选
	Jxwgx: '3', // 进项未勾选
});

export enum YesOrNo {
	Yes = '1',
	No = '0',
}

export enum RoleTypeEnum {
	// 功能
	Functional = '0',
	// 数据
	DataScope = '1',
	// 系统
	System = '2',
}

export enum DataScopeEnum {
	// 个人
	Personal = '1',
	// 所属机构
	AffiliatedOrg = '3',
	// 所属机构及下级
	AffiliatedOrgAndSub = '5',
	// 全部数据
	All = '7',
	// 指定部门
	Assign = '9',
}
// 应用名称对应权限值
export const AppNameMap: any = {
	// 集团开票
	group_invoice: {
		key: 'Kpyw',
		name: '销项',
	},
	// 开票
	invoice: {
		key: 'Kpyw',
		name: '发票',
	},
	// 集团用票
	group_usingtickets: {
		key: 'Ypyw',
		name: '进项',
	},
};

export enum BizChannelEnum {
	// RPA
	RPA = '0',
	// 乐企
	LQ = '1',
}

export enum DefaultAccountEnum {
	// 普通账号
	Normal = 1,
	// 默认账号
	Default = 0,
}
export const isProd: any = {
	production: ['cloud.lqzhcs.com.cn', 'www.lqzhcs.com.cn'],
	development: '111.9.8.241:31215',
};

/**
 * 西平生产环境主机地址
 */
export const XpHost = '39.164.222.103';

/**
 * 客户端下载地址（按渠道区分）
 */
export const ClientDownloadUrls = {
	// 默认渠道
	default: {
		windows: 'https://download.lqzhcs.com.cn/client/%E4%B9%90%E4%BC%81SaaS_Setup_Windows.exe',
		mac: 'https://download.lqzhcs.com.cn/client/%E4%B9%90%E4%BC%81SaaS_Setup_macOS.dmg',
	},
	// 西平渠道
	xp: {
		windows: 'https://download.lqzhcs.com.cn/client/%E4%B9%90%E4%BC%81SaaS_Setup_Windows_xp.exe',
		mac: 'https://download.lqzhcs.com.cn/client/%E4%B9%90%E4%BC%81SaaS_Setup_macOS_xp.dmg',
	},
};

/**
 * 判断当前是否为西平生产环境
 */
export const isXpEnv = (): boolean => {
	return window.location.hostname === XpHost || window.location.host === `${XpHost}:33180`;
};

export enum AccountType {
	// 主账户
	Main = '0',
	// 子账户
	Child = '1',
	// 企业账户
	Enterprise = '2',
}
